import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../Redux/store';
import { getallmeasures } from '../../Redux/Admin_Tasks/MDSSlice';
import { FoundationsSelect } from '../../GenericComponents/select';
import { FoundationsInput } from '../../GenericComponents/input';
import { FoundationsCheckBox } from '../../GenericComponents/checkbox';
import { FoundationsButton } from '../../GenericComponents/button';
import AddMDSC from './AddEditMetadataDrillThruSetColumns';
import { getBaseUrl } from '../../Utils';

interface Add_EditMdsprops {
    onBackButtonClick: () => void;
    editClicked: boolean;
    editMetadataDrillthruSet: any;
}

const AddEditMdsprops: React.FC<Add_EditMdsprops> = ({ editClicked, editMetadataDrillthruSet, onBackButtonClick }) => {
    const [Measures, setMeasures] = useState<any>([]);
    const [selectedMeasure, setSelectedMeasure] = useState<any>();
    const [showComponent, setShowComponent] = useState(false);
    const [MdsData, setMdsData] = useState({
        Id: 0,
        Name: '',
        DrillThruType: '',
        FieldName: '',
        FieldId:-1,
        MeasureId: -1,
        IsSearchAllowed: false,
        IsDefault: 0,
        Visible: false,
        IsColumnSearchAllowed:false,
        FactGroupName: '',
        FromTableQuery: '',
        Fk_DrillThruTypeId: -1,
        fk_FactTable: -1,
        AdditionalButtons:'',
        CreatedOn:'',
        HLSysType:'',
        SortColumns:'',
        SortColumnsForOrderBy:[],
        drillThruSetColumns:[],
    });

    const dispatch: AppDispatch = useDispatch();

    useEffect(() => {
        if (!editClicked) {
            const fetchMeasures = async () => {
                try {
                    const response = await dispatch(getallmeasures());
                    const measures = [...response.payload.data];
                    measures.sort((a: any, b: any) => a.FieldName.localeCompare(b.FieldName));
                    setMeasures(measures);
                } catch (error) {
                    console.error('Error fetching measures:', error);
                }
            };
            fetchMeasures();
        } else {
            setMdsData({
                Id: editMetadataDrillthruSet.Id || 0,
                Name: editMetadataDrillthruSet.Name || '',
                DrillThruType: editMetadataDrillthruSet.DrillThruType || '',
                FieldName: editMetadataDrillthruSet.FieldName || '',
                MeasureId: editMetadataDrillthruSet.MeasureId || -1,
                IsSearchAllowed: editMetadataDrillthruSet.IsSearchAllowed || false,
                IsColumnSearchAllowed:editMetadataDrillthruSet.IsColumnSearchAllowed || false,
                IsDefault: editMetadataDrillthruSet.isDefault || 0,
                Visible: editMetadataDrillthruSet.Visible || false,
                FactGroupName: editMetadataDrillthruSet.FactGroupName || '',
                FromTableQuery: editMetadataDrillthruSet.FromTableQuery || '',
                Fk_DrillThruTypeId: editMetadataDrillthruSet.fk_DrillThruType || -1,
                fk_FactTable: editMetadataDrillthruSet.fk_FactTable || -1,
                AdditionalButtons:editMetadataDrillthruSet.AdditionalButtons || '',
                CreatedOn:editMetadataDrillthruSet.CreatedOn||'',
                HLSysType:editMetadataDrillthruSet.HLSysType||'',
                FieldId:editMetadataDrillthruSet.FieldId||-1,
                SortColumns:editMetadataDrillthruSet.SortColumns||'',
                SortColumnsForOrderBy:editMetadataDrillthruSet.SortColumnsForOrderBy || [],
                drillThruSetColumns:editMetadataDrillthruSet.drillThruSetColumns|| [],

            });
        }
    }, [editClicked, editMetadataDrillthruSet, dispatch]);

    const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const index = Number(event.target.value);
        const measure = Measures[index];
        setSelectedMeasure(measure);
        setMdsData(prevFields => ({
            ...prevFields,
            Id: 0,
            DrillThruType: measure?.DrillThruType || '',
            FieldName: measure?.FieldName || '',
            MetadataId: measure?.FieldKey,
            MeasureId: measure?.FieldKey,
            IsSearchAllowed: measure?.IsSearchAllowed || false,
            IsDefault: measure?.IsDefault || 0,
            Visible: measure?.Visible || false,
            FactGroupName: measure?.FactGroupName,
            FromTableQuery: measure?.FactTableName,
            Fk_DrillThruTypeId: measure?.Fk_DrillThruTypeId,
            fk_FactTable: measure?.fk_FactTable,
            RenderMode: 1,
        }));
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { id, value } = e.target;
        setMdsData(prevFields => ({
            ...prevFields,
            [id]: value,
        }));
    };

    const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { id, checked } = e.target;
        setMdsData(prevFields => ({
            ...prevFields,
            [id]: checked,
        }));
    };

    const handleConfirm = () => {
        if (!MdsData.Name) {
            alert('Please fill in all mandatory fields.');
            return;
        }
        setShowComponent(true);
    };

    const handleBackForm = () => {
        setShowComponent(false);
    };

    return (
        <>
            {showComponent ? (
                <AddMDSC SelectMetadataFormData={MdsData} isEdit={editClicked} handleBackForm={handleBackForm} />
            ) : (
                <div>
                    <div className="float-right margin-top-small">
                        <a id="link_backto_admin_tasks" href={`${getBaseUrl()}/ux/index.html#AdminTasks`}>
                            « Back to Admin Tasks
                        </a>
                    </div>
                    <div className="header">MetadataDrillThru Configuration</div>
                    <div className="row d-block">
                        <div className="content">
                            <div className="float-right" style={{ marginRight: '1rem' ,cursor: 'pointer' }}>
                                <a id="link_backto_admin_tasks" onClick={onBackButtonClick}>
                                    « Back to MetadataDrillThru Configuration
                                </a>
                            </div>
                            <h3 className="fw-normal" style={{ marginLeft: '15px', fontSize: '18px' }}>
                            {editClicked ? 'Edit Metadata Drill-Thru Set' : 'Add New Metadata Drill-Thru Set'}
                            </h3>
                        </div>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', height: '100vh', marginTop: '4rem' }}>
                        {!editClicked && (
                            <div style={{ display: 'grid', gridTemplateColumns: '240px 1fr', gap: '1rem', marginBottom: '2rem' }}>
                                <label htmlFor="measures-dropdown">
                                    Select a Measure<sup style={{ color: 'red' }}>*</sup>:
                                </label>
                                <FoundationsSelect
                                    id="measures-dropdown"
                                    classes="float-centre"
                                    customStyle={{ width: '300px' }}
                                    onChange={handleSelectChange}
                                >
                                    <option value="-Select Metadata-">-Select a Measure-</option>
                                    {Measures.map((item: any, index: any) => (
                                        <option key={index} value={index}>
                                            {item.FieldName}
                                        </option>
                                    ))}
                                </FoundationsSelect>
                            </div>
                        )}
                        <div style={{ display: 'grid', gridTemplateColumns: '240px 1fr', gap: '1rem', marginBottom: '2rem' }}>
                            <label htmlFor="Name">
                                DrillThruSetName<sup style={{ color: 'red' }}>*</sup>:
                            </label>
                            <FoundationsInput
                                type="text"
                                id="Name"
                                customStyle={{ width: '300px' }}
                                onInput={handleInputChange}
                                value={MdsData.Name || ''}
                            />
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: '240px 1fr', gap: '1rem', marginBottom: '2rem' }}>
                            <label htmlFor="DrillThruType">Drill Thru Type:</label>
                            <FoundationsInput
                                type="text"
                                id="DrillThruType"
                                customStyle={{ width: '300px' }}
                                value={MdsData.DrillThruType}
                                disabled
                            />
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: '240px 1fr', gap: '1rem', marginBottom: '1rem', marginRight: '18rem' }}>
                            <label htmlFor="IsSearchAllowed">Allow Drill Thru Search:</label>
                            <FoundationsCheckBox
                                id="IsSearchAllowed"
                                checked={MdsData.IsSearchAllowed}
                                onChange={handleCheckboxChange}
                                toolTipText="Selecting this checkbox will enable the search in the metadata drillthruset."
                                tooltipClasses="info-icon"
                            />
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: '240px 1fr', gap: '1rem', marginBottom: '1rem', marginRight: '18rem' }}>
                            <label htmlFor="IsDefault">Is Default:</label>
                            <FoundationsCheckBox
                                id="IsDefault"
                                checked={MdsData.IsDefault == 1 ? true : false}
                                onChange={handleCheckboxChange}
                                toolTipText='Selecting this checkbox will set the current metadata drillthruset as default drillthuset.'
                                tooltipClasses='info-icon'
                            />
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: '240px 1fr', gap: '1rem', marginBottom: '1rem', marginRight: '18rem' }}>
                            <label htmlFor="Visible">Visible:</label>
                            <FoundationsCheckBox
                                id="Visible"
                                checked={!editClicked? true : MdsData.Visible}
                                onChange={handleCheckboxChange}
                                toolTipText='Selecting this checkbox will decide the visibility of current metadata drillthruset in visual unit.'
                                tooltipClasses='info-icon'

                            />
                        </div>
                        <div style={{ display: 'flex', marginTop: '1rem' }}>
                            <FoundationsButton
                                buttonClasses="ui-button app-button"
                                customStyle={{ marginRight: '1rem' }}
                                id={'cancel'}
                                onClick={onBackButtonClick}
                            >
                                Cancel
                            </FoundationsButton>
                            <FoundationsButton buttonClasses="ui-button app-button" id={'Confirm'} onClick={handleConfirm}>
                                Confirm
                            </FoundationsButton>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default AddEditMdsprops;